export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12406.d91392f7.jpg";